import api from '@/api/API';

// eslint-disable-next-line import/prefer-default-export
export function setup(agencyId: string, apiKey: string): Promise<void> {
  return api
    .put(`agencies/${agencyId}/setup`, { apiKey })
    .then(() => undefined);
}
